import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

export const validateExceptions = exceptions => {
  const errors = {};

  if (exceptions) {
    if (exceptions[Fields.IsDirectCertified]) {
      //either Kin-GAP, Foster OR Case Type Id is required
      if (
        !exceptions[Fields.IsFoster] &&
        !exceptions[Fields.IsKinGap] &&
        !exceptions[Fields.CaseTypeId]
      ) {
        errors[Fields.IsDirectCertified] =
          'Direct Certified requires Foster, Kin-GAP or Case Type';
      }
    }

    if (exceptions[Fields.CaseNumber] && !exceptions[Fields.CaseTypeId]) {
      errors[Fields.CaseTypeId] = 'Case Type is required';
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/validation/ExceptionsValidator.js